import { select, takeLatest } from 'redux-saga/effects'
import { getUserSelector } from '../../user/selectors'
import { IUserState } from '../../user/store/user.types'
import { getCrewSelector } from '../selectors'
import { CrewConstants } from '../store/crew.constants'
import { ICrewState } from '../store/crew.types'

export function* persistShiftStartup() {
  const userState: IUserState = yield select(getUserSelector)
  const { serviceId, userId } = userState
  const crewState: ICrewState = yield select(getCrewSelector)
  const { shift, base, staffingLevel, vehicle, crewList, registrationTailNumber, unitEquipment } = crewState
  const shiftStartUpData = { shift, base, staffingLevel, vehicle, crewList, registrationTailNumber, unitEquipment }
  const fetchedData = localStorage.getItem(`shiftStartupData:${userId}:${serviceId}`)
  if (fetchedData) {
    const shiftStartup = JSON.parse(fetchedData)
    delete shiftStartup.timestamp
    const isDataEqual = JSON.stringify(shiftStartUpData) === JSON.stringify(shiftStartup)
    if (!isDataEqual)
      localStorage.setItem(
        `shiftStartupData:${userId}:${serviceId}`,
        JSON.stringify({ ...shiftStartUpData, timestamp: new Date() })
      )
  } else {
    localStorage.setItem(
      `shiftStartupData:${userId}:${serviceId}`,
      JSON.stringify({ ...shiftStartUpData, timestamp: new Date() })
    )
  }
}

export function* persistShiftStartupSaga() {
  yield takeLatest([CrewConstants.SET_PERSIST_SHIFT_STARTUP], persistShiftStartup)
}
